import script from "./LatestInformation.vue?vue&type=script&lang=ts&setup=true"
export * from "./LatestInformation.vue?vue&type=script&lang=ts&setup=true"

import "./LatestInformation.vue?vue&type=style&index=0&id=8a002ffc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a002ffc"]])

export default __exports__